// fileUploadHandler.js
import heic2any from "heic2any";
import { uploadFile } from "./s3Helper";
import { avifToPng } from "../services/api";
import { postMediaModeration } from "../services/api";

export const handleFileUpload = async (
  file,
  bucketName,
  wheel_id = null,
  segment_id = null
) => {
  try {
    let fileToUpload = file;

    if (file.type == "image/avif") {
      const response = await avifToPng(file);

      if (response.data.data)
        return { fileType: file.type, location: response.data.data?.png_url };
      else return false;
    }

    if (file.type === "image/heic") {
      const convertedBlob = await heic2any({
        blob: file,
        toType: "image/jpeg",
      });
      fileToUpload = new File(
        [convertedBlob],
        file.name.replace(/\.[^/.]+$/, ".jpg"),
        { type: "image/jpeg" }
      );
    }

    const { location, fileKey, fileType } = await uploadFile(
      fileToUpload,
      bucketName
    );

    // Call media moderation API after successful upload only for images
    if (
      location &&
      fileType &&
      (fileType.startsWith("image/") || fileType === "image/webp")
    ) {
      try {
        await postMediaModeration({
          image_url: location,
          wheel_id: wheel_id,
          segment_id: segment_id,
        });
      } catch (moderationError) {
        console.error("Media moderation failed:", moderationError);
        // Continue with the upload even if moderation fails
      }
    }

    return { fileType, location };
  } catch (err) {
    console.error(err);
    throw "An error occurred while processing the file."; // Re-throw the error so that the caller knows about the failure.
  }
};

export function base64ToFile(base64String, fileName = "wheel_image") {
  // Split the base64 string to get the data part and metadata
  const [metadata, data] = base64String.split(",");

  // Extract the file type from metadata
  const matches = metadata.match(/data:(.*);/);
  const fileType = matches ? matches[1] : "image/jpeg";

  // Get the file extension from the file type
  let extension = fileType.split("/")[1];

  // Handle special cases for file extensions
  if (extension === "svg+xml") {
    extension = "svg";
  }

  // Ensure fileName has the correct extension
  const fileNameWithExt = fileName.endsWith(`.${extension}`)
    ? fileName
    : `${fileName}.${extension}`;

  // Convert the base64 data to a binary array
  const binaryData = atob(data);

  // Create an array buffer from the binary data
  const arrayBuffer = new ArrayBuffer(binaryData.length);
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < binaryData.length; i++) {
    uint8Array[i] = binaryData.charCodeAt(i);
  }

  // Create a Blob from the array buffer
  const blob = new Blob([uint8Array], { type: fileType });

  // Create a File from the Blob
  const file = new File([blob], fileNameWithExt, { type: fileType });

  return file;
}

export const getWheelUploadPath = ({ user_id, wheel_id }) => {
  return `uploads/${user_id}/wheels/${wheel_id}/`;
};

export const getBusinessBoxPath = ({ user_id }) => {
  return `uploads/${user_id}/business_box/`;
};

export const getUserProfilePath = ({ user_id }) => {
  return `uploads/${user_id}/user_profile/`;
};
